import { useNavigate  } from "react-router-dom";
import Image from "../images/service.jpg";
export default function CrashSite() {
  const navigate = useNavigate ();
  const logout = () => {
    /*
    history.push({
      pathname: "/logout",
    });
    */
    navigate('/logout');
  };
  return (
    <div className="container_404">
      <div className="main-wrapper">
        <picture className="scarecrow-img">
          <img src={Image} alt="scarecrow" />
        </picture>
        <div className="error-text">
          <div>
            <h2>Aw, Snap ! Something went wrong.</h2>
            <p>
              The page you are looking for get crashed. How you got here is a
              mystery. But you can click the button below to go back to the
              homepage.
            </p>
            <span className="input-group-btn">
              <button className="btn" type="button" onClick={() => logout()}>
                HOME
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
